var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content", attrs: { id: "report_sub_pop" } },
    [
      _c("div", { staticClass: "tab_content_area", attrs: { id: "tab3" } }, [
        _c(
          "div",
          { staticClass: "content_box beforetab" },
          [
            _c(
              "tableau-viz",
              {
                attrs: {
                  id: "tableauViz",
                  src: _vm.url,
                  token: _vm.$store.state.user.updateToken,
                  height: "800",
                  width: "1250",
                },
                on: { firstinteractive: _vm.onFirstInteractive },
              },
              [
                _c("viz-parameter", { attrs: { name: "tabs", value: "yes" } }),
                _c("viz-parameter", {
                  attrs: { name: "toolbar", value: "top" },
                }),
                _c("custom-parameter", {
                  attrs: { name: ":tooltip", value: "yes" },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }